export default __webpack_public_path__ + "static/media/glass_wholesale.7f6621d3.JPG";